<template>
    <div v-if="checkAccess()" class="fondo">
        <div class="columna">
            <div class="areaContainer">
                <TituloVistasComponent titulo="Multas"
                    imagen="https://d2b84d7va2oki2.cloudfront.net/icons/multasBlanco.svg" />
            </div>
            <div class="multas">
                <MultasListComponent />
            </div>
            <div class="multas" style="margin-top: 60px;">
                <div class="message">
                    <p>Tambien te facilitamos el acceso a la gestion de multas de policia caminera</p>
                </div>
                <div class="tramites">
                    <div>
                        <router-link
                            :to="`/sector/Multas/11/56?tramiteTitle=Consultar%20y%20pagar%20Multas%20polic%C3%ADa%20caminera`"
                            style="text-decoration: none">
                            <CardCategoriasComponent :obj="caminera1" />
                        </router-link>
                    </div>
                    <div>
                        <router-link class="cardCategory"
                            :to="`/sector/Multas/11/57?tramiteTitle=Descargo%20Multas%20polic%C3%ADa%20caminera`"
                            style="text-decoration: none">
                            <CardCategoriasComponent :obj="caminera2"/>
                        </router-link>
                    </div>
                </div>
            </div>
            <FlechasComponent tituloIzquierda="Volver atrás" :izquierda="`/portal-transito/10/Licencias/11/Multas`" />
        </div>
    </div>
</template>

<script setup>
import store from "@/store/index"
import { onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import FlechasComponent from "@/components/Flechas/FlechasComponent.vue";
import MultasListComponent from "@/components/Multas/MultasListComponent.vue";
import TituloVistasComponent from "@/components/Titulos/TituloVistasComponent.vue";
import CardCategoriasComponent from "@/components/Cards/CardCategoriasComponent.vue";

const router = useRouter();

const caminera1 = ({
    title: "Consultar y pagar Multas policía caminera",
    sub_title: ""
})

const caminera2 = ref({
    title: "Descargo Multas policía caminera",
    sub_title: ""
})

onBeforeMount(() => {
    if (store.state.user.muniAreas) pushTo()

    if (!checkAccess()) {
        router.push({ name: 'login' })
        return;
    }
})

const checkAccess = () => {
    return store.state.loggedIn;
}

const hasCommons = (user) => {
    if (!user || !user.areaMuni) return false;

    const noCommonsList = ["PRENSA", "INSPECTORES", "MULTAS"];

    // Filtramos las áreas del usuario que NO están en la lista de noCommons
    const areasDiferentes = user.areaMuni.filter(area =>
        !noCommonsList.includes(area.area.area_name)
    );

    // Si hay al menos una área diferente, retorna true, sino false
    return areasDiferentes.length > 0;
}
const pushTo = () => {
    const user = store.state.user;
    const commons = hasCommons(user);

    user.muniAreas.forEach((item) => {
        if (item.area.area_name === "PRENSA" && !commons) {
            router.push({ name: "noticias" });
            return
        }
        if (item.area.area_name === "MULTAS" && !commons) {
            router.push({ name: "multas" });
            return
        }
        if (item.area.area_name === "INSPECTORES" && !commons) {
            router.push({ name: "inspectores" });
            return
        }
    })

    if (commons) {
        router.push({ name: 'muni-agentes' })
        return
    }
}
</script>

<style scoped>
.areaContainer>.general>.circulo {
    width: 34px !important;
    height: 37px !important;
}

.cardCategoriy {
    min-height: 60px !important;
}

.areaContainer>.general {
    margin-left: 0px !important;
}

.fondo {
    background-color: transparent;
    width: 100%;
    min-height: 100vh;
    padding-top: 70px;
    padding-left: 162px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 10%;
}

.columna {
    min-height: fit-content;
    /* Asegúrate de que el contenedor tenga una altura definida */
    width: 100%;
    display: flex;
    /* Habilita flexbox para los hijos */
    flex-direction: column;
    /* Alinea los hijos verticalmente */
    justify-content: space-between;
    /* Distribuye el espacio entre los hijos */
}

.multas {
    margin: 0%;
    width: 100%;
}

.tramites {
    position: relative;
    /*display: grid;
    grid-template-columns: repeat(3, 321px);*/
    display: flex;
    flex-direction: row;
    gap: 22px;
    height: auto;
    width: 1029px;

    /*margin-left: 60px;*/
}

.message {
    margin-bottom: 30px;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 90%;
    /* 18px */
    letter-spacing: -0.8px;
}

@media (max-width: 1360px) {
    .fondo {
        width: 100%;
        min-height: 100vh;
        padding-top: 108px;
        padding-bottom: 104px;
        padding-left: 200px;
    }

    .tramites {
        /*display: grid;
        grid-template-columns: repeat(2, 1fr);*/
        flex-direction: column;
        width: 80%;
        gap: 24px;
        margin: auto;
        margin-top: 0px;
        /* margin-left: 0px; */
    }
}

@media (max-width: 900px) {
    .fondo {
        width: 100%;
        min-height: 100vh;
        padding-top: 108px;
        padding-bottom: 104px;
        padding-left: 0px;
    }
}

@media (max-width: 700px) {
    .fondo {
        width: 100%;
        min-height: 100vh;
        padding-top: 108px;
        padding-bottom: 0px;
        padding-left: 0px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        padding-right: 0%;
    }

    .columna {
        width: 80%;
        min-height: fit-content;
        height: 85vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }

    .tramites {
        position: relative;

        flex-direction: column;
        gap: 8px;
        height: auto;
        width: 100%;

        margin: auto;
        margin-top: 30px;
        margin-bottom: 0px;
    }
}
</style>